<template>
  <div>
    <el-form :inline="true" ref="form" size="mini" label-width="230px">
      <el-form-item :label="$t('benbaozhuangshuliang')" required>
        <el-input-number :min="0" step-strictly :max="printObj.planQuantity - (printObj.printedQuantity ? printObj.printedQuantity : 0)" v-model="printObj.packageNumber"></el-input-number>
      </el-form-item>
      <el-form-item :label="$t('yidayinshuliang') + '/' + $t('jihuashuliang')" required>
        <div style="color: black;">{{ printObj.printedQuantity ? printObj.printedQuantity : 0 }}/{{ printObj.planQuantity }}</div>
      </el-form-item>
      <el-form-item :label="$t('picihao')" required>
        <el-input v-model="printObj.batchNo"></el-input>
      </el-form-item>
      <el-form-item style="width: 100%;text-align: center;">
        <el-radio v-model="selected" :label="1" @input="selectRecord()">{{ $t('weishu') }}</el-radio>
        <el-radio v-model="selected" :label="0" @input="selectRecord()">{{ $t('renwubiaoqian') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('biaoqianyangshi')">
        <div id="batchPrint">
          <div :id="'printContent_' + index" v-for="(item, index) in printObjList" :key="index" style="font-size: 10px;padding:4px;box-sizing: border-box;border: 1px solid transparent;line-height: 18px;" :style="{ width: getDpi(95) + 'px', height: getDpi(66.9) + 'px', 'margin-top': index == 0 ? '0px' : '-1px' }" class="printFontFamily">
            <div style="display: flex;color: black;">
              <div style="width:50%;border-left: 1px solid black;display: flex;flex-direction: column;">
                <div style="min-height: 38px;display:flex;border-top: 1px solid black;">
                  <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('xiangmuhao') }}</div>
                  <div style="width:70%;text-align: center;">{{ item.material.code }}</div>
                </div>
                <div style="min-height: 38px;display:flex;border-top: 1px solid black;">
                  <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('pinming') }}</div>
                  <div style="width:70%;text-align: center;">{{ item.material.name }}</div>
                </div>
                <div style="display:flex;border-top: 1px solid black;flex: 1;">
                  <div style="width:30%;text-align: center;border-right: 1px solid black;">{{ $t('riqi') }}</div>
                  <div style="width:70%;text-align: center;">{{ dayjs().format('YYYY-MM-DD') }}</div>
                </div>
              </div>
              <div style="width:50%;border: 1px solid black;border-bottom: 1px solid white;display: flex;justify-content: center;align-items: center;">
                <div v-if="item.labelBarcodeNumber" style="">
                  <vue-qr :text="item.labelBarcodeNumber" :margin="10" :size="100"></vue-qr>
                </div>
                <div v-if="!item.labelBarcodeNumber" style="">
                  <vue-qr :text="'Example'" :margin="10" :size="100"></vue-qr>
                </div>
              </div>
            </div>
            <div style="min-height: 38px;display: flex;border: 1px solid black;border-bottom: 0px solid white;color: black;">
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-right: 1px solid black;">{{ $t('jitaihao') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ item.equipment.name }}</div>
              </div>
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-left: 1px solid black;border-right: 1px solid black;">{{ $t('moju') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ item.mould.no }}</div>
              </div>
            </div>
            <div style="min-height: 38px;display: flex;border: 1px solid black;border-bottom: 0px solid white;color: black;">
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-right: 1px solid black;">{{ $t('shuliang') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ printObj.packageNumber }}</div>
              </div>
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-left: 1px solid black;border-right: 1px solid black;">{{ $t('picihao') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ printObj.batchNo }}</div>
              </div>
            </div>

            <div style="min-height: 38px;display: flex;border: 1px solid black;color: black;">
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-right: 1px solid black;">{{ $t('biaoqianhao') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ item.labelBarcodeNumber }}</div>
              </div>
              <div style="width:50%;display:flex;">
                <div style="width:30%;display: flex;justify-content: center;align-items: center;border-left: 1px solid black;border-right: 1px solid black;">{{ $t('gongdanhao') }}</div>
                <div style="width:70%;display: flex;justify-content: center;align-items: center;line-height: 14px;">{{ item.no }}</div>
              </div>
            </div>
            <div :style="gapStyle"></div>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div style="text-align: center;padding-bottom: 20px;">
      <el-button :loading="printLoading" type="primary" @click="printRuike" style="width: 130px;">{{ $t('dayin') }}</el-button>
      <el-button :loading="printLoading" type="primary" @click="showBatchPrintDialog" style="width: 130px;">{{ $t('piliangdayin') }}</el-button>
    </div>
    <el-dialog v-dialog-drag :visible.sync="isShowBatchPrintDialog" append-to-body="append-to-body" width="300">
      <el-form :inline="true" size="mini" label-width="230px">
        <el-form-item :label="$t('dayinzhangshu')" required>
          <el-input-number :min="1" :max="50" step-strictly v-model="printCount"></el-input-number>
        </el-form-item>
        <el-form-item :label="'每张标签纸高度（px）'" required>
          <el-input-number v-model="pCHeight"></el-input-number>
        </el-form-item>
      </el-form>
      <div style="text-align: center;padding-bottom: 20px;">
        <el-button @click="isShowBatchPrintDialog = false" style="width: 130px;">{{ $t('quxiao') }}</el-button>
        <el-button :loading="printLoading" type="primary" @click="batchPrintRuike" style="width: 130px;" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '工单执行-瑞科打印标签' } }">{{ $t('queren') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import print from 'print-js';
import VueQr from 'vue-qr';
import jsPDF from 'jspdf';

export default {
  components: {
    VueQr
  },
  data() {
    return {
      blobs: [],
      printObj: {},
      selected: null,
      gapStyle: {},
      printContentHeight: {},
      barcodeList: [],
      printObjList: [],
      isShowBatchPrintDialog: false,
      printCount: null,
      pCHeight: 252,
      printLoading: false
    };
  },
  created() {
    this.printObj = this.$attrs.ruikePrintObj;
    //获取标签内容
    this.http
      .post('/web/print/record/getPrintInformation', { id: this.printObj.id })
      .then(res => {
        this.$set(this.printObj, 'packageNumber', res.data.packageNumber);
        this.$set(this.printObj, 'batchNo', res.data.batchNo);
        this.$set(this.printObj, 'currentOrder', res.data.currentOrder);
        this.$set(this.printObj, 'printedQuantity', res.data.printedQuantity);
        this.printObjList.push(this.printObj);
      })
      .catch(err => {
        this.$message.error(err);
      });
  },
  methods: {
    getDpi(num) {
      const inch = document.createElement('div');
      inch.style.width = '1in';
      document.body.appendChild(inch);
      const dpi = inch.offsetWidth;
      document.body.removeChild(inch);
      const unit = Number(num);
      const inchs = unit / 25.4;
      const px = inchs * dpi;
      return Math.round(px);
    },
    selectRecord() {
      if (this.selected == 0) {
        this.printObj.packageNumber = 0;
      } else if (this.selected == 1) {
        this.printObj.packageNumber = this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0);
      }
    },
    printRuike() {
      if (this.printObj.packageNumber === null || this.printObj.packageNumber === undefined) {
        this.$message.error(this.$t('benbaozhuangshuliang') + this.$t('不能为空'));
        return;
      }
      if (this.printObj.batchNo === null || this.printObj.batchNo === undefined || this.printObj.batchNo === '') {
        this.$message.error(this.$t('picihao') + this.$t('不能为空'));
        return;
      }
      if (this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0) === 0 && this.selected !== 0) {
        this.$message.error("可打印数量不足");
        return;
      }
      //获取条码再打印
      this.printLoading = true;
      this.http.post('/web/print/record/getBatchPrintInformation', { woId: this.printObj.id, printCount: 1, packageNumber: this.printObj.packageNumber }).then(res2 => {
        if (res2.data !== null) {
          this.$set(this.printObjList[0], 'labelBarcodeNumber', res2.data[0].labelBarcodeNumber);
        }
        setTimeout(() => {
          this.printObj.businessType = 11;
          this.printObj.woNo = this.printObj.no;
          this.printObj.woId = this.printObj.id;
          // 新增打印记录
          this.http
            .post('/web/print/record/createPrintRecord', this.printObj)
            .then(res => {
              this.$emit('closeDialog');
              this.domToPdfBase64('printContent_0', 'p');
            })
            .catch(err => {
              this.printLoading = true;

              this.$message.error(err);
            })
            .finally(() => { });
        }, 50);
      });
    },
    batchPrintRuike() {
      if (this.printCount == null || this.printCount == undefined) {
        this.$message.error(this.$t('dayinzhangshu') + this.$t('不能为空'));
        return;
      }
      this.printLoading = true;

      this.printObj.businessType = 11;
      this.printObj.woNo = this.printObj.no;
      this.printObj.woId = this.printObj.id;
      //获取批量打印的标签号
      this.http
        .post('/web/print/record/getBatchPrintInformation', { woId: this.printObj.id, printCount: this.printCount, packageNumber: this.printObj.packageNumber })
        .then(res => {
          this.printObjList = [];
          for (let item of res.data) {
            let print = this.utils.copy(this.printObj);
            print.currentOrder = item.currentOrder;
            print.labelBarcodeNumber = item.labelBarcodeNumber;
            this.printObjList.push(print);
          }
          this.printContentHeight = { height: this.pCHeight + 'px' };
          let batchPrint = document.getElementById('batchPrint');
          setTimeout(() => {
            // 新增批量打印记录
            this.http
              .post('/web/print/record/batchCreatePrintRecord', this.printObjList)
              .then(res => {
                this.blobs = [];
                for (let index = 0; index < this.printObjList.length; index++) {
                  this.domToPdfBase64('printContent_' + index, 'p');
                }
                this.$message.success(this.$t('chenggong'));
                this.$emit('closeDialog');
              })
              .catch(err => {
                this.$message.error(err);
                this.printLoading = false;
              })
              .finally(() => { });
          }, 50);
        })
        .catch(err => {
          this.printLoading = false;
          this.$message.error(err);
        });
    },
    showBatchPrintDialog() {
      if (this.printObj.packageNumber === null || this.printObj.packageNumber === undefined) {
        this.$message.error(this.$t('benbaozhuangshuliang') + this.$t('不能为空'));
        return;
      }
      if (this.printObj.batchNo === null || this.printObj.batchNo === undefined || this.printObj.batchNo === '') {
        this.$message.error(this.$t('picihao') + this.$t('不能为空'));
        return;
      }
      if (this.printObj.planQuantity - (this.printObj.printedQuantity ? this.printObj.printedQuantity : 0) === 0 && this.selected !== 0) {
        this.$message.error("可打印数量不足");
        return;
      }
      this.isShowBatchPrintDialog = true;
    },

    domToPdfBase64(targetId, printOrientation) {
      var targetDom = document.getElementById(targetId); //你的目标元素id
      var copyDom = targetDom.cloneNode(true); // 克隆节点
      copyDom.style.width = targetDom.offsetWidth + 'px';
      copyDom.style.height = targetDom.scrollHeight + 'PX'; // 获得高度
      document.body.appendChild(copyDom); // 插入节点

      html2canvas(copyDom).then(canvas => {
        document.body.removeChild(copyDom); // 删除节点
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;

        var imgWidth = contentWidth;
        var imgHeight = contentHeight;

        var pageData = canvas.toDataURL('image/jpeg', 1.0);
        //第一个参数： l：横向  p：纵向;第二个参数：测量单位（"pt"，"mm", "cm", "m", "in" or "px"）;第三个参数：可以是下面格式，默认为“a4”
        var pdf = new jsPDF('l', 'px', [imgWidth, imgHeight]);
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        // pdf.save(targetId + `.pdf`);

        let pdf64 = pdf.output('blob');

        this.blobs.push(pdf64);

        if (this.blobs.length == this.printObjList.length) {
          this.sends();
        }
      });
    },
    sleep(numberMillis) {
      var now = new Date();
      var exitTime = now.getTime() + numberMillis;
      while (true) {
        now = new Date();
        if (now.getTime() > exitTime) return;
      }
    },

    sends() {
      const formData = new FormData();
      for (let index = 0; index < this.blobs.length; index++) {
        formData.append('files[]', this.blobs[index]);
      }
      this.http
        .post('http://127.0.0.1:17521/printLocalPDF', formData, {
          headers: {
            'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
          }
        })
        .then(res => {
          console.log(res);
        })
        .finally(() => {
          this.printLoading = false;
        });
      this.blobs = [];
    }
  }
};
</script>

<style>
@media print {
  @page {
    size: auto;
    margin: 0;
  }

  body {
    margin: 0;
    padding: 0;
  }
}

.printFontFamily {
  font-family: '微软雅黑';
}
</style>

<style scoped>
div {
  box-sizing: border-box;
}
</style>
